import Button from "components/general/buttonv2";
import {
  StyledContainer,
  StyledTitle,
  StyledTitleBelow,
  StyledWrapper,
} from "components/home/styling";
import { pricingData } from "data/homeData";
import { DISCORD_LINK, downloadButtonText, downloadsDisabled } from "data/variables";
import styled from "styled-components";

const StyledWrapperSpecified = styled(StyledWrapper)`
  margin-top: ${(props) => (props.noSpacing ? "0" : "-14rem")};
  padding-top: ${(props) => (props.noSpacing ? "8rem" : "14rem")};
  position: relative;
  padding-bottom: 6rem;
`;
const StyledButtonGroup = styled.div`
  display: flex;
  margin-top: 2rem;
  > * {
    margin: 0 0.5rem;
  }
`;
const Pricing = ({ $noSpacing }) => {
  return (
    <StyledWrapperSpecified noSpacing={$noSpacing}>
      <StyledContainer>
        <StyledTitle>{pricingData.title}</StyledTitle>
        <StyledTitleBelow>{pricingData.subtitle}</StyledTitleBelow>
        <StyledButtonGroup>
          <Button
            disabled={downloadsDisabled}
            alignSelf="center"
            to="/download"
            buttonPrimary={true}
          >
            {downloadButtonText}
          </Button>
          <Button alignSelf="center" href={DISCORD_LINK}>
            Join Redact Discord
          </Button>
        </StyledButtonGroup>
      </StyledContainer>
    </StyledWrapperSpecified>
  );
};

export default Pricing;
